/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/tender';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "AuthenticationResult": {
                "fields": {
                  "authenticationType": {
                    "type": ".squareup.esperanto.model.AuthenticationResult.AuthenticationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isSuccess": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verificationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "threeDsAuthenticationResult": {
                    "type": ".squareup.esperanto.model.ThreeDSAuthenticationResult",
                    "id": 4
                  },
                  "threeDsScopeEvaluation": {
                    "type": ".squareup.esperanto.model.ThreeDSScopeEvaluation",
                    "id": 5
                  }
                },
                "nested": {
                  "AuthenticationType": {
                    "values": {
                      "DEFAULT_ENUM_DO_NOT_USE": 0,
                      "THREE_DS": 1
                    }
                  },
                  "typed_authentication_result": {
                    "oneof": ["threeDsAuthenticationResult"]
                  },
                  "typed_scope_evaluation": {
                    "oneof": ["threeDsScopeEvaluation"]
                  }
                }
              },
              "ThreeDSAuthenticationResult": {
                "fields": {
                  "authenticationProvider": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "authenticationValue": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transactionStatus": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "transactionStatusReason": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "authnResponseTransactionStatus": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "resultsRequestTransactionStatus": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "eciValue": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "protocolVersion": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "directoryServerId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "wasChallenged": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "threeDsServerTxnId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "threedsToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.common.tender.ThreeDSFailureReason",
                    "id": 11,
                    "rule": "optional"
                  },
                  "threeDsError": {
                    "type": ".squareup.common.tender.ThreeDSError",
                    "id": 12,
                    "rule": "optional"
                  },
                  "mandate": {
                    "type": ".squareup.common.tender.AuthenticationResult.Mandate",
                    "id": 13,
                    "rule": "optional"
                  },
                  "riskRecommendation": {
                    "type": ".squareup.common.tender.AuthenticationResult.RiskRecommendation",
                    "id": 14,
                    "rule": "optional"
                  },
                  "scope": {
                    "type": ".squareup.common.tender.AuthenticationResult.Scope",
                    "id": 15,
                    "rule": "optional"
                  },
                  "challengeCancel": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "directoryServerIdentifier": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "authnRequestorUnitToken": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  }
                }
              },
              "ThreeDSScopeEvaluation": {
                "fields": {
                  "mandate": {
                    "type": ".squareup.common.tender.AuthenticationResult.Mandate",
                    "id": 1,
                    "rule": "optional"
                  },
                  "riskRecommendation": {
                    "type": ".squareup.common.tender.AuthenticationResult.RiskRecommendation",
                    "id": 2,
                    "rule": "optional"
                  },
                  "scope": {
                    "type": ".squareup.common.tender.AuthenticationResult.Scope",
                    "id": 3,
                    "rule": "optional"
                  },
                  "customScore": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "riskChargebackLiabilityRecommendation": {
                    "type": ".squareup.common.tender.AuthenticationResult.ChargebackLiability",
                    "id": 5,
                    "rule": "optional"
                  },
                  "scaExemption": {
                    "type": ".squareup.common.tender.AuthenticationResult.ScaExemption",
                    "id": 6,
                    "rule": "optional"
                  },
                  "chargebackLiableParty": {
                    "type": ".squareup.common.tender.AuthenticationResult.ChargebackLiability",
                    "id": 7,
                    "rule": "optional"
                  },
                  "chargebackLiabilityReason": {
                    "type": ".squareup.common.tender.AuthenticationResult.ChargebackLiabilityReason",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthenticationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthenticationResult?.nested?.AuthenticationType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.ThreeDSAuthenticationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.ThreeDSScopeEvaluation) {
  $root.addJSON(jsonData);
}

/**
 * Authentication result for a payment, e.g. 3DS authentication for cards.
 *
 * SOURCE AuthenticationResult @ squareup/esperanto/model/authentication.proto at 13:1
 */
export const AuthenticationResult = $root.lookupType('squareup.esperanto.model.AuthenticationResult');
fixType(AuthenticationResult);
Builder.createAndAttachToType(AuthenticationResult);
/**
 * SOURCE AuthenticationType @ squareup/esperanto/model/authentication.proto at 14:3
 */
AuthenticationResult.AuthenticationType = $root.lookupEnum('squareup.esperanto.model.AuthenticationResult.AuthenticationType').values;
/**
 * Additional results specific to card authentications using the 3DS 2.0 protocol,
 * which is used for eCommerce transactions in the UK and AU.
 *
 * SOURCE ThreeDSAuthenticationResult @ squareup/esperanto/model/authentication.proto at 46:1
 */
export const ThreeDSAuthenticationResult = $root.lookupType('squareup.esperanto.model.ThreeDSAuthenticationResult');
fixType(ThreeDSAuthenticationResult);
Builder.createAndAttachToType(ThreeDSAuthenticationResult);
/**
 * Additional scope eligibility details specific to card authentications using
 * the 3DS 2.0 protocol, which is used for eCommerce transactions.
 *
 * SOURCE ThreeDSScopeEvaluation @ squareup/esperanto/model/authentication.proto at 130:1
 */
export const ThreeDSScopeEvaluation = $root.lookupType('squareup.esperanto.model.ThreeDSScopeEvaluation');
fixType(ThreeDSScopeEvaluation);
Builder.createAndAttachToType(ThreeDSScopeEvaluation);